import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginGuard} from 'guards/login.guard';
import {UserImportComponent} from './user-import.component';

const routes: Routes = [
  {path: 'user/import', component: UserImportComponent, canActivate: [LoginGuard]},
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
  providers: [],
})

export class UserImportRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/user/user-import/user-import-routing.module.ts